/*
 * Copyright (c) 2022. American Express Company
 */

export enum StatsCardColour {
    WHITE = 'statsBgWhite',
    BLUE = 'statsBgBlue',
    DARK_BLUE = 'statsBgDarkBlue'
}

export class StatsCardViewModel {
    onClick: () => void | Promise<void>;
    colour: StatsCardColour;
    topText: string;
    middleText: string;
    bottomText: string;
    ctaText: string;
    tooltipText: string;
    className?: string;
}
